import { useContext } from 'react';
import { MetricsContext } from './metrics-context';

/**
 * Hook to access the metrics tracking instance.
 */

export const useMetrics = () => {
  const metrics = useContext(MetricsContext);
  if (!metrics)
    throw new Error('useMetrics must be used within an MetricsProvider');
  return metrics;
};
